import type { ScheduleHeaderId } from '@/types/gql.generated';
import { Text } from '@/ui';

const getImageName = (headerId: ScheduleHeaderId): string => {
  return headerId
    .replace(/agendahero/i, 'agenda_hero')
    .replace(/_1$/, '')
    .split('_')
    .join(' ')
    .toLowerCase();
};

type Props = {
  id: ScheduleHeaderId;
  isSelected?: boolean;
};

export const HeaderTitle = ({ id, isSelected }: Props) => {
  return (
    <Text
      bg={isSelected ? 'purple.500' : 'white'}
      borderBottomRadius="4"
      color={isSelected ? 'white' : 'currentcolor'}
      fontWeight="medium"
      left="4"
      lineHeight="1"
      pos="absolute"
      px="2"
      py="1"
      textTransform="capitalize"
      top="0"
      zIndex="1"
    >
      {getImageName(id)}
    </Text>
  );
};
